import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { media } from 'lib/style-utils';

class Circle extends PureComponent {

  render() {
    const { color } = this.props;

    const Wrapper = styled.div`
      content: "";
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, -100vw);
      width: 100vh;
      height: 100vh;
      border-radius: 50%;
      border: 100vw solid ${color};
      box-sizing: content-box;
      z-index: 10;
      opacity: 1;
      transition: opacity 1s ease-in-out;

      &:hover {
        opacity: 0;
      }

      ${media.tablet`
        top: 60px;
        width: 90vw;
        height: 90vw;
      `}
      ${media.mobile`
        top: 78px;
        width: 100vw;
        height: 100vw;
      `}
    `;

    return <Wrapper color={color}></Wrapper>
  };
}

export default Circle;



// WEBPACK FOOTER //
// ./src/components/Shared/Circle.js